var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.productAlternative.productImageUrl
    ? _c("div", { staticClass: "productImage" }, [
        _c(
          "a",
          {
            attrs: {
              href: `${_vm.basedir}/${_vm.productAlternative.productPageLink}`,
            },
          },
          [
            _c("v-lazy-image", {
              attrs: {
                alt: _vm.productAlternative.name,
                "src-placeholder": `${_vm.productAlternative.productImageUrl}?w=${_vm.imageSize}`,
                srcset: _vm.imageSet.set,
                src: _vm.productAlternative.productImageUrl
                  ? `${_vm.newImageUrl}?w=${_vm.imageSize}`
                  : _vm.productAlternative.productImageUrl +
                    "?w=" +
                    _vm.imageSize,
                size: _vm.imageSet.size,
              },
              on: { error: _vm.handleImageError },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }